export default "__VITE_ASSET__tK0CsEQr__"